import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppSettingsService } from '@oa/shared-core';

const markerClustererSrc = '../assets/js/markerclusterer.js';

@Injectable()
export class ScriptLoaderService {
  constructor(readonly appSettings: AppSettingsService,
    ) {}

  async loadGoogleMaps() {
    console.log('ScriptLoaderService: loadGoogleMaps');
    const settings = await firstValueFrom(this.appSettings.settings$.pipe(filter(s => !!s)));
    const useKey = settings.googleMapsKey;
    const googleMapsSrc = '//maps.googleapis.com/maps/api/js?v=quarterly&key=' + useKey + '&libraries=drawing,geometry,places';
    return this.loadViaScriptTag(googleMapsSrc, 'google');
  }

  loadMarkerClusterer() {
    console.log('ScriptLoaderService: loadMarkerClusterer');
    return this.loadViaScriptTag(markerClustererSrc, 'MarkerClusterer');
  }

  async loadViaScriptTag(injectedScriptSource: string, nameOfGlobal: string) {
    if (nameOfGlobal in this.loadRecords) {
      return Promise.resolve(this.loadRecords[nameOfGlobal]);
    }
    this.loadRecords[nameOfGlobal] = new Promise<any>((resolve, reject) => {
      const scriptTag = document.createElement('script');
      scriptTag.src = injectedScriptSource;
      scriptTag.addEventListener('load', function (e) {
        console.log('ScriptLoaderService: ' + nameOfGlobal + ' loaded!');
        console.info(e);
        window.addNewGlobal(nameOfGlobal);
        resolve((window as any)[nameOfGlobal]);
      }, false);
      scriptTag.addEventListener('error', reject, false);
      console.log('ScriptLoaderService: adding script tag to head for ' + nameOfGlobal);
      document.head.appendChild(scriptTag);
    });
    await this.loadRecords[nameOfGlobal];
  }

  readonly loadRecords: { [key: string]: Promise<any> } = {};
}

declare global {
  interface Window {
    addNewGlobal(name: string): boolean;
  }
}

if (!Window.prototype.addNewGlobal) {
  Window.prototype.addNewGlobal = function(name: string): boolean {
    return name in this;
  };
}
